import { RouteType } from "types/RouteType";

const projectInfoRoute: RouteType = {
  name: "MM Projects",
  path: "/mm/projects",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Projects",
      component: () => import("./ProjectInfo.Header"),
      enableRefreshButton: false,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ProjectInfo.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  // Creede, 2026-10-16: "Projects, Administration, Detailing Pipeline,
  // Production, Loads, Shipping Calendar, Daily Report." Companies, which he
  // didn't name, goes last.
  menuOrder: 1,
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    // The project form is long (six sections), so it asks for more than the
    // host's 400px default rather than carrying its own scroll container.
    {
      name: "Add Project",
      title: "New Project",
      height: 600,
      component: () => import("./ProjectInfoDialogs/ProjectFormDialog"),
    },
    {
      name: "Edit Project",
      title: "Edit Project",
      height: 600,
      component: () => import("./ProjectInfoDialogs/ProjectFormDialog"),
    },
  ],
};

export default projectInfoRoute;
